import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';
import Header from '../Layout/Header';

const PrivacyPolicy: React.FC = () => {
  return (
    <Box>
      <Header />
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Paper elevation={1} sx={{ p: 4 }}>
          <Typography variant="h3" component="h1" gutterBottom sx={{ color: 'primary.main' }}>
            プライバシーポリシー
          </Typography>
          
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
            最終更新日: 2024年12月
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              1. 基本方針
            </Typography>
            <Typography variant="body1" paragraph>
              DeckWin（以下「当サービス」）は、ユーザーの個人情報保護を重要視し、個人情報の保護に関する法律、その他関係法令等を遵守し、適切な取り扱いを行います。
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              2. 収集する個人情報
            </Typography>
            <Typography variant="body1" paragraph>
              当サービスでは、以下の個人情報を収集することがあります：
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <Typography component="li" variant="body1">メールアドレス</Typography>
              <Typography component="li" variant="body1">ユーザー名</Typography>
              <Typography component="li" variant="body1">ゲームの対戦記録データ</Typography>
              <Typography component="li" variant="body1">デッキ構成情報</Typography>
              <Typography component="li" variant="body1">サービス利用に関する統計情報</Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              3. 個人情報の利用目的
            </Typography>
            <Typography variant="body1" paragraph>
              収集した個人情報は、以下の目的で利用します：
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <Typography component="li" variant="body1">サービスの提供・運営</Typography>
              <Typography component="li" variant="body1">ユーザーアカウントの管理</Typography>
              <Typography component="li" variant="body1">対戦記録の保存・表示</Typography>
              <Typography component="li" variant="body1">統計情報の生成・分析</Typography>
              <Typography component="li" variant="body1">サービスの改善・開発</Typography>
              <Typography component="li" variant="body1">お問い合わせへの対応</Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              4. 個人情報の第三者提供
            </Typography>
            <Typography variant="body1" paragraph>
              当サービスは、法令に基づく場合を除き、ユーザーの同意なく個人情報を第三者に提供することはありません。
            </Typography>
            <Typography variant="body1" paragraph>
              ただし、以下の場合には個人情報を提供することがあります：
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <Typography component="li" variant="body1">法令に基づく場合</Typography>
              <Typography component="li" variant="body1">人の生命、身体または財産の保護のために必要がある場合</Typography>
              <Typography component="li" variant="body1">公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合</Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              5. Cookieの使用
            </Typography>
            <Typography variant="body1" paragraph>
              当サービスでは、サービスの利便性向上のためCookieを使用しています。Cookieは、ユーザーのブラウザに保存される小さなテキストファイルです。
            </Typography>
            <Typography variant="body1" paragraph>
              また、Google Analyticsを使用してアクセス解析を行っています。Google Analyticsはデータの収集のためにCookieを使用しています。
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              6. 個人情報の管理
            </Typography>
            <Typography variant="body1" paragraph>
              当サービスは、個人情報への不正アクセス、紛失、破壊、改ざん、漏洩などを防ぐため、適切なセキュリティ対策を実施しています。
            </Typography>
            <Typography variant="body1" paragraph>
              個人情報は、利用目的の達成に必要な期間のみ保管し、不要になった個人情報は適切に削除または廃棄します。
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              7. ユーザーの権利
            </Typography>
            <Typography variant="body1" paragraph>
              ユーザーは、自身の個人情報について以下の権利を有します：
            </Typography>
            <Box component="ul" sx={{ pl: 3, mb: 2 }}>
              <Typography component="li" variant="body1">個人情報の開示を求める権利</Typography>
              <Typography component="li" variant="body1">個人情報の訂正・追加・削除を求める権利</Typography>
              <Typography component="li" variant="body1">個人情報の利用停止・消去を求める権利</Typography>
              <Typography component="li" variant="body1">アカウントの削除を求める権利</Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              8. プライバシーポリシーの変更
            </Typography>
            <Typography variant="body1" paragraph>
              当サービスは、必要に応じてプライバシーポリシーを変更することがあります。変更後のプライバシーポリシーは、当サービス上に掲載した時点から効力を生じるものとします。
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" component="h2" gutterBottom sx={{ color: 'primary.main' }}>
              9. お問い合わせ
            </Typography>
            <Typography variant="body1" paragraph>
              本プライバシーポリシーに関するお問い合わせは、サービス内のお問い合わせフォームよりご連絡ください。
            </Typography>
          </Box>

          <Box sx={{ mt: 6, p: 3, backgroundColor: 'grey.50', borderRadius: 1 }}>
            <Typography variant="body2" color="text.secondary" align="center">
              DeckWin - カードゲームの対戦結果記録サービス
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;